const React = require('react');
const Base = require('../Base');


module.exports = ({
  label,
  className,
  ...props
}) => {
  return (
    <div className={className || ''}>
      <div className="c0 f12 h12 lh lts0em fw4 mb14">{label}</div>
      <Base {...props}/>
    </div>
  );
};
